import {Component, inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {InputComponent} from '../form/input/input.component';

export interface EmailFormData {
  email: string;
}

interface EmailDetailsForm {
  email: FormControl<string | null>;
}

/**
 * Wiederverwendbare E-Mail-Formularlogik - eingebettet sowohl im Verifizierungs-Wizard
 * (EmailStepComponent) als auch im EmailDetailsAdjustModalComponent.
 */
@Component({
  selector: 'app-email-details-form',
  standalone: true,
  imports: [TranslatePipe, ReactiveFormsModule, InputComponent],
  templateUrl: './email-details-form.component.html',
})
export class EmailDetailsFormComponent implements OnInit {

  @Input() initialData: EmailFormData | null;
  // Erlaubt unterschiedliche data-cy-Präfixe je nach Einbettungskontext (Wizard-Step vs. Modal)
  @Input() testIdPrefix = 'email-data-';

  form: FormGroup<EmailDetailsForm>;

  private readonly fb = inject(FormBuilder);

  ngOnInit(): void {
    this.form = this.fb.group({
      email: new FormControl(this.initialData?.email ?? '', [Validators.required, Validators.email]),
    });
  }

  isValid(): boolean {
    return this.form.valid;
  }

  getFormValue(): EmailFormData {
    return this.form.getRawValue() as EmailFormData;
  }
}
